// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"404":"3f1b192f","498":"f21a7c2a","513":"2d2a8692"}[chunkId] + ".chunk.js";
};